import adminAuthService from "../../services/admin-auth.service";

const authAdmin = {
    namespaced: true,
    state: () => {
        const adminStr = localStorage.getItem("sportips_auth_admin");
        const admin = adminStr ? JSON.parse(adminStr) : null;
        return {
            isLogged: admin ? true : false,
            adminData: admin ? admin : null,
        };
    },
    mutations: {
        SET_LOGGED(state, value) {
            state.isLogged = value;
        },
        SET_ADMIN_DATA(state, data) {
            state.adminData = data;
        },
        CLEAR_ADMIN_DATA(state) {
            state.isLogged = false;
            state.adminData = null;
        },
    },
    actions: {
        async login({ commit }, login_details) {
            let res = await adminAuthService.login(login_details);

            if (res && res.id && res.username) {
                commit("SET_LOGGED", true);
                commit("SET_ADMIN_DATA", res);
                localStorage.setItem("sportips_auth_admin", JSON.stringify(res));
            }
            return res;
        },
        logout({ commit }) {
            commit("CLEAR_ADMIN_DATA");
            localStorage.removeItem("sportips_auth_admin");
        },
    },
    getters: {
        isLogged: (state) => state.isLogged,
        adminData: (state) => state.adminData,
        getUsername: (state) => state.adminData && state.adminData.username,
        getAdminData: (state) => state.isLogged && state.adminData,
        hasVerificateurRights: (state) =>
            state.isLogged && state.adminData && (
                state.adminData.privilege === 'pc_course' ||
                state.adminData.privilege === 'respo_medical' ||
                state.adminData.privilege === 'coordinateur'
            ),
        isSportipsAdmin: (state) =>
            state.isLogged && state.adminData && state.adminData.privilege === 'sportips',
        hasAdminRights: (state) =>
            state.isLogged && state.adminData && (
                state.adminData.privilege === 'sportips' ||
                state.adminData.privilege === 'admin'
            ),
        hasSuperAdminRights: (state) =>
            state.isLogged &&
            state.adminData &&
            state.adminData.privilege === 'sportips' &&
            (state.adminData.username === 'florian' || state.adminData.username === 'yann'),
        hasModuleAccess: (state, getters, rootState) => {
            if (!state.isLogged) return false;
            if (state.adminData && state.adminData.privilege === 'sportips') return true;
            if (!state.adminData || !state.adminData.list_modules) return false;
            const id_module = rootState.module && rootState.module.id;
            return state.adminData.list_modules.includes(id_module);
        },
    },
};

export default authAdmin;

